import React from "react";
import styled from "@emotion/styled";
// import Fg from "./FooterGroup";
import ft from "../images/logo.png";

const FooterBox = styled.footer`
  width: 100%;
  font-size: 12px;
  color: #fff;

  background-color: #131313;
`;

const FooterA = styled.div`
  padding: 60px 0px 20px;
  img {
    width: 100%;
    max-width: 100px;
    display: block;
    margin: auto;
    @media screen and (max-width: 767px) {
      max-width: 60px;
    }
  }
`;

const FooterB = styled.div`
  width: 100%;
  background-color: #000;
`;

const FooterContainer = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: auto;
  padding: 20px 0px;
`;

const FooterService = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1000px) {
    flex-direction: column-reverse;
    text-align: center;
  }
`;

const FooterCompany = styled.p`
  margin-right: 25px;
  @media screen and (max-width: 1000px) {
    margin-right: 0px;
  }
`;

// const FooterUl = styled.ul``;

const FooterLi = styled.li`
  padding: 0px 10px;
  display: inline-block;
  @media screen and (max-width: 1000px) {
    border-right: 1px solid #fff;
    &:nth-of-type(4) {
      border-right: unset;
    }
  }
  &:first-of-type {
    padding: 0px 10px 0px 0px;
  }
  &:last-child {
    padding: 0px;
    @media screen and (max-width: 1000px) {
      display: none;
    }
  }
  a {
    color: #fff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const FooterRecommend = styled.p`
  color: #999;
  margin-top: 10px;
  text-align: center;
`;

// const FooterGroup = styled.div`
//   font-size: 12px;
//   width: 80%;
//   max-width: 1024px;
//   margin: auto;
//   padding-top: 40px;
//   display: flex;
//   justify-content: space-between;
// `;

// const Column = styled.div`
//   p {
//     color: red;
//     letter-spacing: 1px;
//     padding-bottom: 8px;
//   }
//   ul {
//     vertical-align: top;
//     display: inline-block;
//     &:not(:first-of-type) {
//       margin-left: 36px;
//     }
//     a {
//       color: white;
//     }
//   }
// `;

const Alone = styled.div`
  display: flex;
  align-items: center;
  > a {
    img {
      width: 100%;
      max-width: 75px;
      margin-right: 5px;
      transform: translateY(-2px);
      @media screen and (max-width: 767px) {
        margin-right: 0;
      }
    }
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 15px;
  }
`;

const Footer = () => {
  return (
    <FooterBox>
      <FooterB>
        <FooterContainer>
          <FooterService>
            <Alone>
              <a
                href="https://www.toyota.com.tw/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ft} alt="" />
              </a>
              <FooterCompany>
                © HOTAI MOTOR CO., LTD. 和泰汽車股份有限公司
              </FooterCompany>
            </Alone>
            <ul>
              <FooterLi>
                <a href="https://www.toyota.com.tw/TFAQ/">常見問題</a>
              </FooterLi>
              <FooterLi>
                <a href="https://www.toyota.com.tw/contact.aspx">聯絡我們</a>
              </FooterLi>
              <FooterLi>
                <a href="https://www.toyota.com.tw/privacy.aspx">隱私權說明</a>
              </FooterLi>
              <FooterLi>
                <a href="https://www.toyota.com.tw/rights.aspx">版權聲明</a>
              </FooterLi>
              <FooterLi>客服專線0800221345</FooterLi>
            </ul>
          </FooterService>
          <FooterRecommend>建議使用 Chrome 瀏覽器。</FooterRecommend>
        </FooterContainer>
      </FooterB>
    </FooterBox>
  );
};

export default Footer;
